/**
 * Returns today's date as YYYY-MM-DD in the USER'S local timezone
 * (not the server's). Uses `en-CA` because its default date format is
 * already YYYY-MM-DD with zero-padded month/day.
 *
 * The backend never assumes a timezone; it simply uses whatever date
 * string the frontend sends as the key. This prevents "midnight bugs"
 * when a user crosses the day boundary in a TZ different from the server.
 */
export function getLocalDateString(d = new Date()) {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(d);
  } catch {
    // Fallback: ISO slice. Still local if toISOString() is called after offset adjustments,
    // but good enough as a last resort.
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }
}
